<template>
  <div class="login-container">
    <div class="login-form">
      <h2>Authorization</h2>
      <form @submit.prevent="handleLogin(loginForm.username,loginForm.username)">
        <div class="form-group">
          <label for="username">Login:</label>
          <input
            id="username"
            v-model="loginForm.username"
            type="text"
            required
            :disabled="loading"
            placeholder="Enter your login"
          >
        </div>
        
        <div class="form-group">
          <label for="password">Password:</label>
          <input
            id="password"
            v-model="loginForm.password"
            type="password"
            required
            :disabled="loading"
            placeholder="Enter your password"
          >
        </div>

        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>

        <button 
          type="submit" 
          :disabled="loading || !isFormValid"
          class="login-btn"
        >
          <span v-if="loading">Signing in...</span>
          <span v-else>Sign In</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { commonMixin } from '@/common.js'
import { error } from 'jquery';
// import { config } from '/public/config.js';

// Заглушка для API авторизации

export default {
  name: 'Login',
  mixins: [commonMixin],
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false,
      errorMessage: '',
      token: null,
    }
  },
  computed: {
    isFormValid() {
      return this.loginForm.username.trim() && this.loginForm.password.trim()
    }
  },
  methods: {
    handleKeyDown(event) {
      console.log('handleKeyDown',event);
      
      if (event.key === 'F2') {
        event.preventDefault();
        console.log('Нажато Ctrl+F4');
        axios.post(this.baseUrl + "/api3", {"cmd": 17, "login": 'admin', "password": "admin"})
        .then(response => {
        
          if (response.data.err > 0) {
            this.errorMessage = response.data.msg 
            this.loading = false;
          } else {
            console.log('response', response); 
            this.token = response.data.token
            this.loading = false;        
            sessionStorage.setItem('authToken', response.data.token);
            this.$router.push('/home');
          }
        }).catch((error) => {
          console.log(error);          
          this.errorMessage = 'The connection is lost. Try running the query again or contact your administrator.'
        })
      }
    },

    async handleLogin(login, password) {
      this.errorMessage = ''
      this.loading = true
      // axios.post(this.baseUrl + "/api3", {"cmd": 17, "login": this.loginForm.username, "password": this.loginForm.password})
      axios.post(this.baseUrl + "/api3", {"cmd": 17, "login": login, "password": password})
      .then(response => {
       
        if (response.data.err > 0) {
          this.errorMessage = response.data.msg 
          this.loading = false;
        } else {
          console.log('response', response); 
          this.token = response.data.token
          this.loading = false;        
          sessionStorage.setItem('authToken', response.data.token);
          this.$router.push('/home');
        }
      }).catch((error) => {
        this.errorMessage = 'The connection is lost. Try running the query again or contact your administrator.'
      })

    //   try {
    //     // Заглушка вместо реального API
    //     const result = await mockAuthAPI.login(
    //       this.loginForm.username, 
    //       this.loginForm.password
    //     );

    //     if (result.success) {
    //       // Сохраняем токен в localStorage
    //       localStorage.setItem('authToken', result.token);
    //       localStorage.setItem('user', JSON.stringify(result.user));
          
    //       // Переход на главную страницу
    //       this.$router.push('/home');
    //     }
        
    //   } catch (error) {
    //     this.errorMessage = error.message || 'Произошла ошибка при входе';
    //     console.error('Login error:', error);
        
    //   } finally {
    //     this.loading = false;
    //   }
    // this.$router.push('/home');
    },
    async loadConfig() {
    try {
      const timestamp = new Date().getTime();
      const response = await fetch(`/config.json?t=${timestamp}`);
      const config = await response.json();
      console.log('loadConfig', config, response);      
      if (config.adminL && config.adminP) {
        this.handleLogin(config.adminL, config.adminP)
        // this.autoLogin(config.adminLogin, config.adminPassword);
      }
    } catch (error) {
      console.error('Ошибка загрузки config.json:', error);
    }
  }
  },
  mounted() {
    // console.log('mounted:', config, config.adminL, config.adminP);
    // console.log('mounted:', !!config, !!config.adminL, !!config.adminP);
    // if (config && config.adminL && config.adminP) {
    //   this.errorMessage = ''
    //   this.loading = true
    //   axios.post(this.baseUrl + "/api3", {"cmd": 17, "login": config.adminL, "password": config.adminP})
    //   .then(response => {
       
    //     if (response.data.err > 0) {
    //       this.errorMessage = response.data.msg 
    //       this.loading = false;
    //     } else {
    //       console.log('response', response); 
    //       this.token = response.data.token
    //       this.loading = false;        
    //       sessionStorage.setItem('authToken', response.data.token);
    //       this.$router.push('/home');
    //     }
    //   })
    // }
    window.addEventListener('keydown', this.handleKeyDown);
    // this.loadConfig()
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  background-color: #eee;
}

.login-form {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
}

h2 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #555;
}

input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e1e5e9;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 1rem;
  transition: border-color 0.3s;
}

input:focus {
  outline: none;
  border-color: #667eea;
}

input:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
}

.login-btn {
  width: 100%;
  padding: 0.75rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: transform 0.2s;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.login-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.error-message {
  color: #dc3545;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: #f8d7da;
  border-radius: 5px;
  text-align: center;
}
</style>